import { useState, useEffect } from 'react';
import api from '../services/api';

export function useAllCoinsPriceBalanceData(range = '1m') {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchData() {
      // Don't fetch if range is null or undefined
      if (!range) {
        setData(null);
        setLoading(false);
        setError(null);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const params = new URLSearchParams({ range });
        const response = await api.get(`/api/portfolio/all-coins-price-balance-data?${params}`);

        if (!cancelled) {
          setData(response.data);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.response?.data?.error || err.message);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [range]);

  return { data, loading, error };
} 